import { render, staticRenderFns } from "./gl-mark.vue?vue&type=template&id=2f16881f&scoped=true&"
import script from "./gl-mark.vue?vue&type=script&lang=js&"
export * from "./gl-mark.vue?vue&type=script&lang=js&"
import style0 from "./gl-mark.vue?vue&type=style&index=0&id=2f16881f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16881f",
  null
  
)

export default component.exports